import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { useState, useRef } from "react";
import { Calendar } from "primereact/calendar";
import { useFormik } from "formik";
import moment from "moment";
import { Toast } from "primereact/toast";
import ViewDietChart from "./viewDietTab/viewDietChart";

interface AddDietFormValues {
  dietstartdate: Date | null;
}

const AddDiet = (props: any) => {
  const navigate = useNavigate();
  const toast = useRef<Toast>(null);

  const onBackButtonClick = () => {
    props.setIsBackButtonPressed(true);
  };

  const handleSubmit = async (values: AddDietFormValues) => {
    const protocolData = {
      userId: props.userTreatmentid,
      customer: props.customerName,
      dietstartdate: moment(values.dietstartdate).format("YYYY-MM-DD"),
    };

    localStorage.setItem("protocol_chatbot_data", JSON.stringify(protocolData));

    navigate("/chatbot", { state: protocolData });
  };

  const formik = useFormik({
    initialValues: {
      dietstartdate: null,
    },
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  const onGenerateDietClick = () => {
    if (!formik.values.dietstartdate) {
      toast.current?.show({
        severity: "warn",
        summary: "Important field is missing",
        detail: "Please select date",
        life: 3000,
      });
      return;
    }

    formik.handleSubmit();
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    <>
      <Toast ref={toast} />
      <div className="flex">
        <div className="col 2">
          <div className="flex">
            <Button
              className="orange-btn back-btn"
              icon="pi pi-chevron-left"
              onClick={onBackButtonClick}
            />
            <h3 className="mt-2 ml-2">Diet History</h3>
          </div>
        </div>
        <div className="d-flex right mr-5">
          <>
            <label className="col-5" style={{ fontSize: "18px" }}>
              Diet start date
              <span className="text-red">*</span>{" "}
            </label>
            <Calendar
              id="dietstartdate"
              placeholder="DD/MM/YYYY"
              className="relative"
              showIcon
              value={formik.values.dietstartdate}
              onChange={(e) => formik.setFieldValue("dietstartdate", e.value)}
              minDate={today}
              dateFormat="dd/mm/yy"
            />
            {/* {formik.errors.dietstartdate && formik.touched.dietstartdate && (
              <div className="error-msg">{formik.errors.dietstartdate}</div>
            )} */}

            <Button
              className="dietgenerate-btn ml-2"
              label="Generate Diet"
              // onClick={() => navigate("/chatbot")}
              // onClick={() => formik.handleSubmit()}
              onClick={onGenerateDietClick}
              // disabled={!formik.values.dietstartdate}
            />
          </>
        </div>
      </div>

      <div className="">
        <ViewDietChart userTreatmentid={props.userTreatmentid} />
      </div>
    </>
  );
};

export default AddDiet;
